import BaseLayout from "@/v2/components/BaseLayout";

export default function AboutPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Vad är Korthet.se?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Korthet.se sammanfattar nyheter från svenska publikationer med AI, så att du snabbt får en överblick och kan välja vad du vill läsa vidare hos originalkällan.",
        },
      },
      {
        "@type": "Question",
        name: "Hur fungerar sammanfattningarna?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Vi hämtar nyheter från publika RSS-flöden, AI skapar en kort sammanfattning och punktlista, och vi länkar alltid till originalartikeln hos källan.",
        },
      },
      {
        "@type": "Question",
        name: "Ersätter Korthet.se journalistiken?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Nej. Korthet.se är ett komplement som hjälper dig hitta vidare till originalartiklar. Publikationerna äger innehållet och vi skriver aldrig om artiklarna till egna nyheter.",
        },
      },
      {
        "@type": "Question",
        name: "Har Korthet.se en politisk agenda?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Nej. Korthet.se har ingen politisk eller redaktionell agenda. Sammanfattningarna är utformade för att återge innehållet så neutralt som möjligt.",
        },
      },
    ],
  };

  return (
    <BaseLayout
      title="Om Korthet.se – vem vi är, hur AI används och varifrån nyheterna kommer"
      description="Korthet.se är en svensk nyhetstjänst som sammanfattar nyheter från etablerade källor med AI. Läs om vem som driver tjänsten, hur pipelinen fungerar och hur du kontaktar oss."
      canonicalPath="/om"
      jsonLd={jsonLd}
    >
      <h1 className="k2-h1">Om Korthet.se</h1>

      <p className="k2-summary">
        Korthet är en svensk nyhetstjänst för dig som snabbt vill förstå vad som
        händer – utan att läsa flera långa artiklar. Korthet ersätter inte
        originaljournalistiken, utan hjälper dig vidare till den.
      </p>

      <h2 className="k2-h2">Vad är Korthet?</h2>
      <p>
        Korthet samlar nyheter från etablerade svenska nyhetskällor och ger dig
        en kort överblick: vad som hänt, vilka punkter som är viktigast och
        vilken typ av innehåll det är. Därefter länkar vi vidare till
        originalartikeln, som alltid är den primära källan.
      </p>

      <h2 className="k2-h2">Hur fungerar det?</h2>
      <ul className="k2-bullets">
        <li>Vi hämtar artiklar via publika RSS- och Atom-flöden.</li>
        <li>Texten analyseras och sammanfattas automatiskt med AI.</li>
        <li>
          Varje artikel får en sammanfattning, viktiga punkter och en
          artikelprofil (huvudämne, faktakaraktär och berörda ämnen).
        </li>
        <li>
          Artiklar publiceras bara när sammanfattningen är komplett – ofullständiga
          eller för korta underlag publiceras inte alls.
        </li>
        <li>Vi använder inte publikationernas bilder.</li>
      </ul>

      <h2 className="k2-h2">Varifrån kommer informationen?</h2>
      <p>
        Varje sammanfattning baseras på den angivna originalkällan. Korthet
        bedriver ingen egen nyhetsrapportering, skriver inte om artiklar till
        egna nyheter och länkar alltid vidare till källan. Källa och
        publiceringsdatum visas på varje artikel.
      </p>

      <h2 className="k2-h2">Hur AI används</h2>
      <p>
        Sammanfattningarna genereras automatiskt av en språkmodell utifrån den
        publicerade originaltexten. Pipelinen extraherar artikeltexten, skapar
        sammanfattning och punktlista, klassificerar kategori och ämnen och
        märker resultatet som AI-genererat i gränssnittet.
      </p>
      <p>
        AI kan göra fel. Innehåll som inte går att sammanfatta korrekt filtreras
        bort, men om något ser felaktigt ut ska originalartikeln alltid ha
        företräde – och gärna höra av dig så rättar vi det.
      </p>

      <h2 className="k2-h2">Ansvar och oberoende</h2>
      <p>
        Korthet.se drivs av Stefan Andersson, Sverige. Tjänsten har ingen
        politisk eller redaktionell agenda, och sammanfattningarna är utformade
        för att återge originalinnehållet så neutralt som möjligt.
      </p>

      <h2 className="k2-h2">Kontakt</h2>
      <p>
        Frågor, rättelser eller synpunkter:{" "}
        <a href="mailto:hello@korthet.se">hello@korthet.se</a>
      </p>

      <h2 className="k2-h2">Vår princip</h2>
      <p>
        <strong>Mindre brus. Mer koll.</strong>
      </p>
    </BaseLayout>
  );
}

